import { useBreakpointValue } from '@gemini/core';
import { useEvent, useMount, useSessionStorage, useUpdateEffect } from 'react-use';
import { useAppContext } from '../../contexts/AppContext';
// Get the current scroll position
const getScrollTop = () => Math.floor(document.documentElement.scrollTop);
const scrollTo = (top) => window.scrollTo({ top });
/**
 * Stores scroll position if scrolling ends
 * Scrolls to specific position (if stored)
 * Scrolls to top if classifieds are updated
 * @param key string local storage key
 */
export const useAutoScroll = (key = 'last-scroll-position') => {
    const classifieds = useAppContext((store) => store.classifieds);
    const [lastScrollPosition, setLastScrollPosition] = useSessionStorage(key, 0);
    const isLG = useBreakpointValue({ base: 'base', lg: 'lg' }) === 'lg';
    // Scroll to last position but only on mount and if there is a last position stored
    useMount(() => {
        // Disable auto scrolling on desktop view
        if (isLG)
            return;
        // Scroll immediately to the saved position to avoid a visual flash when returning from CDP to SERP on mobile
        // Delaying the scroll causes a visible jump
        if (lastScrollPosition > 0)
            setTimeout(() => scrollTo(lastScrollPosition), 1);
    });
    // Scroll to top if classifieds are changing but omit the first change because we should already be at top
    useUpdateEffect(() => scrollTo(0), [classifieds]);
    // Store the current scroll position for later usage
    useEvent('scrollend', () => setLastScrollPosition(getScrollTop()));
};
